<template>
<div class="main-raised-page-wrapper">
  <div class="section">
  <div class="container">
      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <h2 class="title text-danger">Medical Student Assistants</h2>
          <h4>The Dermatology Interest Group for medical students has compiled a list of students here that can be contacted to assist dermatologists with their research.</h4>
          <h5><a href="https://www.nzdsi.org/Students/dig.aspx" target="_blank">More about the DIG Group</a></h5>
        </div>
          <div class="md-layout-item md-size-100 md-card">
              <md-card-content>
            <h5 class="title text-black">Camellia Nguyen</h5>
            <p><b>Posted</b> 03/11/2025</p>
            <p><b>Personal Contact:</b> <a href="mailto:camellia.nguyen04@gmail.com">camellia.nguyen04@gmail.com</a></p>
              <p><b>Occupation:</b> 3rd Year medical student at University of Auckland</p>
              <p><b>Location:</b> Auckland.</p>
              <p><b>Interests:</b> 
              My interests include:</p>
              <ul>
                <li>skin cancer</li>
                <li>hair and scalp disorders</li>
                <li>acne</li>
                <li>autoimmune diseases</li>
                <li>cosmetic dermatology</li>
              </ul>
              <p><b>Relevant experience:</b>
                At present I currently have no relevant experience in research, however I am keen to begin engaging and participating in research.</p>
              </md-card-content>
          </div>
          <div class="md-layout-item md-size-100 md-card">
              <md-card-content>
            <h5 class="title text-black">Louis Alexander Tomlinson</h5>
            <p><b>Posted</b> 14/10/2025</p>
            <p><b>Personal Contact:</b> <a href="mailto:tomlinsonlouis446@gmail.com">tomlinsonlouis446@gmail.com</a></p>
            <p><b>University Contact:</b> <a href="mailto:ltom143@aucklanduni.ac.nz">ltom143@aucklanduni.ac.nz</a></p>
              <p><b>Location:</b> Cambridge/Hamilton (preferred) or Auckland.</p>
              <p><b>Interests:</b> With my strong interest in dermatology, I am keen in particular to explore the digital and technological aspects of dermatology and imaging tools, as well as new innovations that can enhance diagnosis, management, and patient care overall. I would like to contribute to areas that can combine and improve clinical practice with emerging technology. </p>
              <p><b>Relevant experience:</b>
                Validation of AIPDerm’s Differential Diagnostic Accuracy on common skin diseases in New Zealand patients.</p>
              <p>Contributor of the DermNet Synonym Project.</p>
              </md-card-content>
          </div>
        
          <div class="md-layout-item md-size-100 md-card">
              <md-card-content>
            <h5 class="title text-black">Aimee Louise Pickford</h5>
            <p><b>Posted</b> 01/10/2025</p>
            <p><b>Contact:</b> <a href="mailto:aimee.pickford@icloud.com">aimee.pickford@icloud.com</a></p>
              <p><b>Location:</b> Auckland</p>
              <p><b>Interests:</b> Acne, inflammatory skin conditions, burns/wound healing, skin infections, autoimmune skin disease and skin cancer.</p>
              <p><b>Relevant experience:</b></p>
              <p>DermNet Volunteer<br>Collaborated with students from the University of Otago and the University of Auckland to create a comprehensive synonym database for dermatological conditions on DermNet Pro. This project aimed to improve searchability, support international terminology, and enhance user access. Responsibilities included:</p>
              <ul>
                <li>Researching synonyms using scientific databases (NCBI, Google Scholar, Elsevier, NIH).</li>
                <li>Ensuring terminology accuracy, including UK/US variations.</li>
                <li>Peer-reviewing and editing contributions in collaboration with other volunteers.</li>
              </ul>
              <p>Biomedical Honours Research Student<br>Conducted research on the therapeutic and prognostic potential of the Fn14 receptor in HER2+ breast cancer under the supervision of Professor Heather Cunliffe. Responsibilities included:</p>
              <ul>
                <li>Independently managing laboratory experiments and collaborating with peers.</li>
                <li>Optimising transfection conditions and overexpressing Fn14 in breast cancer cells.</li>
                <li>Investigating EGFR receptor stability and signalling pathway responses.</li>
                <li>Assessing treatment sensitivity, invasive potential, and migratory behaviour of cancer cells.</li>
                <li>Performing bioinformatic analyses using ROC plotter and cBioPortal.</li>
                <li>Presenting findings through talks, data visualisation, and thesis preparation.</li>
              </ul>
              </md-card-content>
          </div>
          <div class="md-layout-item md-size-100 md-card">
              <md-card-content>
            <h5 class="title text-black">Neakiry Kivi</h5>
            <p><b>Contact:</b> <a href="mailto:neakiryk@outlook.com">neakiryk@outlook.com</a></p>
              <p><b>Location:</b> Wellington</p>
              <p><b>Interests:</b> Medical dermatology; Integrated healthcare delivery; Medical education; Telemedicine; Health promotion; Lifestyle and preventative medicine</p>
              <p><b>Relevant experience:</b> Assistant research fellow at the Medical Research Institute of New Zealand. Experience with carrying out remote patient surveys/data collection, audits, clinical research recruitment, systematic literature reviews, and database/collection building. Keen to build experience in a variety of dermatological research areas and methodologies.
            </p>
              </md-card-content>
          </div>
          <div class="md-layout-item md-size-100 md-card">
              <md-card-content>
            <h5 class="title text-black">Loimata Fa'alogo-Lilo</h5>
            <p><b>Contact:</b> <a href="mailto:loimatafaalogolilo@gmail.com">loimatafaalogolilo@gmail.com</a></p>
              <p><b>Location:</b> Auckland</p>
              <p><b>Interests:</b> I have a wide interest in dermatological research including skin of colour.</p>
              <p><b>Relevant experience:</b> I have conducted research on the representation of skin of colour in the Australasian Journal of Dermatology which was presented at NZDSI 2023. I have also completed an elective in dermatology.
            </p>
              </md-card-content>
          </div>
          <div class="md-layout-item md-size-100 md-card">
              <md-card-content>
            <h5 class="title text-black">Jacob Junior Kang (JJ Kang)</h5>
            <p><b>Contact:</b> <a href="mailto:jkan344@aucklanduni.ac.nz">jkan344@aucklanduni.ac.nz</a></p>
              <p><b>Location:</b> Auckland</p>
              <p><b>Interests:</b> I have interests in researching on atopic dermatitis, acne, eczema and psoriasis but I am open to any topic. I am very keen on working with data analytics and want to contribute to the developing community of integrating pattern recognition as a tool for diagnosis and management with machine learning across the industry. I believe it has potential to conduct multivariate analyses on biopsies and become a powerful tool for future dermatology.</p>
              <p><b>Relevant experience:</b> I have previously published an article for Dermnet after doing literature review on the topic Talimogene Laherparepvec and planning on writing more articles in the future. I have some experience in handling and analysing data throughout my business degree and hoping to apply it through diverse statistical analyses for data results.
            </p>
              </md-card-content>
          </div>
          <div class="md-layout-item md-size-100 md-card">
              <md-card-content>
            <h5 class="title text-black">Louise Kim</h5>
            <p><b>Contact:</b> <a href="mailto:kimlo515@student.otago.ac.nz">kimlo515@student.otago.ac.nz</a></p>
              <p><b>Location:</b> Christchurch</p>
              <p><b>Interests:</b> I have a wide interest in dermatological research including, but not limited to, Atopic Dermatitis and Cosmetic Dermatology.</p>
              <p><b>Relevant experience:</b> I am passionate and determined to learn and gain experience beyond the research skills that are taught within medical school!
            </p>
              </md-card-content>
          </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "Students",
  components: {
  },
  bodyClass: "students",
};
</script>
<style lang="scss" scoped>
</style>
